import useWeakMap from "../../../utils/useWeakMap"
import { isLayer } from "../validator/useLayerIdentity";
import { useQueryOriginSource } from "../useQueryOriginal";

const store = useWeakMap();

const useSubcribeWhenSourceChanges = (originalSource, cb) => {
    if (isLayer(originalSource)) {
        originalSource = useQueryOriginSource(originalSource);
    }
    if (!store.has(originalSource)) {
        store.set(originalSource, new Set());
    }
    store.get(originalSource).add(cb);
    return () => store.get(originalSource).delete(cb);
}

export const emitSourceChanges = (source, key, value) => {
    if (!store.has(source)) return;
    store.get(source).forEach(cb => cb.call(null, key, value));
}

export default useSubcribeWhenSourceChanges;